import { ResolveFn } from '@angular/router';
import { PublicFaqCategory } from '../models/public-faq-category';
import { inject } from '@angular/core';
import { PublicFaqPageDataSourceService } from '../services/public-faq-page-data-source.service';

export const publicFetchFaqCategoriesResolver: ResolveFn<
  PublicFaqCategory[]
> = () => {
  const faqPageDataSource = inject(PublicFaqPageDataSourceService);

  return faqPageDataSource.fetchCategories();
};
